import { Column, Grid } from "@carbon/react";

import { ReportSection } from "./ReportSection";
import { ActivationRequiredWarning, PageBanner } from "../../components";

import barIcon from "./../../assets/icons/bar.svg";
import balanceIcon from "./../../assets/icons/balance.svg";
import houseIcon from "./../../assets/icons/house.svg";
import pieChartIcon from "../../assets/icons/pie-chart.svg";

export const View = (props) => {
  return (
    <>
      <PageBanner
        pageTitle={"Reports"}
        pageSubtitle={
          "Access comprehensive reports of all your data captured from your SwitchApp account"
        }
        pageDescription={
          "Detailed breakdown all your transactions, payouts, revenue and other activities on your account."
        }
        iconSource={pieChartIcon}
        hideLink
      />

      <ActivationRequiredWarning
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <Grid>
        <Column sm={4} md={8} lg={16}>
          <div className="flex-container flex-break--small report-section--container">
            <div className="flex-box mr-5">
              <ReportSection
                title="Balance"
                description="Conciliate your balance and download your transaction history."
                iconSource={balanceIcon}
                targetUrl={"balance"}
              />
            </div>
            <div className="flex-box mr-5">
              <ReportSection
                title="Reconciliation"
                description="Transactions that have settled to your bank account including a categorized breakdown for each payout."
                iconSource={houseIcon}
                targetUrl={"reconciliation"}
              />
            </div>
            <div className="flex-box">
              <ReportSection
                title="Revenue"
                description="Get reports on recognized and deferred revenue, charts to track your revenue over time."
                iconSource={barIcon}
                targetUrl={"revenue"}
              />
            </div>
          </div>
        </Column>
      </Grid>
    </>
  );
};
